import { Link } from "react-router";
import { Ansicht } from "../design/Ansicht";
import { Symbol } from "../design/Symbol";
import { useSammlung } from "../plattform/lesemodelle";
import { useNetz } from "../plattform/Offline";
import { gemerkteReviere, useSitzung } from "../plattform/sitzung";

/**
 * Reviere (nur Jagdherr, oberflaeche.md §3.1): je Revier `link` „<Reviername>“. Bis die Liste gelesen ist und ohne Netz
 * zeigt die Ansicht die Reviere, die das Gerät von der Anmeldung kennt (Stände vor Ort anlegen im Wald, revier/05).
 */
export function Reviere() {
  const { uid } = useSitzung();
  const netz = useNetz();
  const reviere = useSammlung(uid ? `personen/${uid}/reviere` : null);
  const gelesen = !reviere.laedt && netz && !reviere.fehler;
  const zeilen = reviere.daten.length || gelesen
    ? reviere.daten.map((r) => ({ id: r._id, name: String(r["Revier"]) }))
    : gemerkteReviere(uid).map((r) => ({ id: r.Revier, name: r.Reviername }));
  return (
    <Ansicht name="Reviere" symbol="karte">
      <section className="liste-bereich" role="region" aria-label="Reviere">
        {zeilen.map((r) => (
          <Link key={r.id} to={`/reviere/${r.id}`} className="zeile zeile--knopf platte" aria-label={r.name}>
            <Symbol name="jagdherr" />
            <span className="zeile__t">{r.name}</span>
            <Symbol name="weiter" className="zeile__pfeil" />
          </Link>
        ))}
        {zeilen.length === 0 && gelesen ? <p className="leer platte"><Symbol name="karte" /><span>Noch kein Revier</span></p> : null}
      </section>
    </Ansicht>
  );
}
